import { render } from "./PopupCard.vue?vue&type=template&id=0d5c461e&scoped=true"
import script from "./PopupCard.vue?vue&type=script&lang=js"
export * from "./PopupCard.vue?vue&type=script&lang=js"

import "./PopupCard.vue?vue&type=style&index=0&id=0d5c461e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d5c461e"]])

export default __exports__